export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7850.cfab9c1c.jpg";